var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../Themes/colors';
var TabsWrapper = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== 'isDisabled'; },
})(function (_a) {
    var _b;
    var theme = _a.theme, isDisabled = _a.isDisabled;
    return (_b = {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight: 0,
            '& .tabHeader': {
                flexShrink: 0,
                flexWrap: 'wrap',
                overflow: 'hidden',
                alignItems: 'center',
            },
            '& .tabData': {
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                overflowX: 'hidden',
            },
            '& .tabContentSplit': {
                gap: 12,
                alignItems: 'stretch',
                minHeight: 0,
                height: '100%',
                flexWrap: 'nowrap',
            },
            '& .tabContentPrimary': {
                flex: '1 1 58%',
                minWidth: 0,
                minHeight: 0,
                overflow: 'auto',
                paddingRight: 4,
                paddingBottom: '15px',
            },
            '& .tabContentPreview': {
                flex: '0 0 auto',
                width: '42%',
                minWidth: 300,
                minHeight: 0,
                overflow: 'hidden',
                transition: 'all 0.3s ease',
            }
        },
        _b[theme.breakpoints.down('lg')] = {
            '& .tabData': {
                paddingRight: 0,
            },
            '& .tabContentSplit': {
                height: 'auto',
            },
            '& .tabContentPrimary, & .tabContentPreview': {
                flex: '1 1 auto',
                minWidth: 0,
                overflow: 'visible',
                paddingRight: 0,
            },
        },
        _b['& .MuiTabs-root'] = {
            opacity: isDisabled ? 0.5 : 1,
            pointerEvents: isDisabled ? 'none' : 'auto',
            minHeight: 42,
            flexGrow: 1,
            minWidth: 0,
        },
        _b['& .MuiTabs-list'] = {
            gap: 12,
        },
        _b['& .MuiTabs-indicator'] = {
            backgroundColor: baseColors.successPreset[10],
            height: 3,
            borderRadius: '3px 3px 0 0',
        },
        _b['& .MuiTabs-scrollButtons'] = {
            color: baseColors.greyPreset[10],
        },
        _b['& .MuiTabs-root .MuiTab-root'] = __assign(__assign({}, theme.typography.body1), { minWidth: 'unset', padding: '10px 0px', margin: '0 8px', lineHeight: '100%', color: baseColors.greyPreset[5], minHeight: '42px', textTransform: 'none', '&:hover': {
                color: baseColors.greyPreset[10],
                opacity: 1,
            }, '&.Mui-selected': {
                color: baseColors.successPreset[10],
                fontWeight: 600,
            }, '&.Mui-disabled': {
                color: baseColors.greyPreset[20],
                opacity: 0.5,
            } }),
        _b);
});
export default TabsWrapper;
